import { db } from '@/shared/db/database';
import { parsePgDateTime } from '@/shared/utils/datetime';
import { getSyncWorker } from './syncWorker.singleton';

/** Resetea todos los items `failed_permanent` a `pending` para reintentar. */
export async function retryAllFailed(): Promise<number> {
  const failed = await db.syncQueue.where('status').equals('failed_permanent').toArray();
  for (const item of failed) {
    await db.syncQueue.update(item.id, {
      status: 'pending' as const,
      attempts: 0,
      lastError: null,
    });
  }
  return failed.length;
}

export async function discardFailed(id: string): Promise<void> {
  await db.syncQueue.delete(id);
}

const RESEND_WINDOW_DAYS = 15;

/** Resend is only offered for marcajes within ±15 days of today — outside that, the backend won't accept it. */
function isWithinResendWindow(datetime: string): boolean {
  const d = parsePgDateTime(datetime);
  if (Number.isNaN(d.getTime())) return false;
  const diffDays = Math.abs(d.getTime() - Date.now()) / (1000 * 60 * 60 * 24);
  return diffDays <= RESEND_WINDOW_DAYS;
}

/**
 * Requeues every local timelog stuck in 'pending' or 'failed' whose own
 * marcaje date is within ±15 days of today — reintenta el payload guardado
 * tal cual, sin reconstruirlo. Triggers one immediate sync pass at the end.
 * Returns how many timelogs were requeued.
 */
export async function retryAllWithinWindow(): Promise<number> {
  const candidates = await db.timelogs.where('syncStatus').anyOf(['pending', 'failed']).toArray();
  const eligible = candidates.filter((row) => isWithinResendWindow(row.dateTimeEvent));

  for (const row of eligible) {
    await db.syncQueue.update(row.localId, {
      status: 'pending' as const,
      attempts: 0,
      lastError: null,
    });
    await db.timelogs.update(row.localId, { syncStatus: 'pending' });
  }

  if (eligible.length > 0) getSyncWorker()?.syncNow();
  return eligible.length;
}
